export const post = {
  category: 'Seasonal',
  title: 'Santa Barbara holiday tree lightings: where to see the magic',
  deck:
    'Every lighting from Carpinteria to Goleta, with parking notes, start times, and an honest read on which ones are worth a late bedtime.',
  published: 'Published November 24',
  updated: 'Updated for 2026',
  readMinutes: 7,
  author: 'Rachel',
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/ed61eded-cc1d-4e05-bac0-53dd8ae8de9c.jpg',
  imageAlt:
    'A decorated holiday tree lit with warm string lights at dusk, families watching from behind',
  intro:
    'Tree lightings are the rare December event that works with every age at once — short, free, outside, and over before a meltdown. Here is every one happening this year, in the order they fall, with the practical stuff nobody puts on the flyer.',
  sections: [
    {
      heading: 'Before you go',
      body: 'All of these run 45 minutes to an hour, and every one of them starts after dark, which in late November means around 5pm. Feed everyone first — the food trucks always have a twenty-minute line right when the music starts. Bring more layers than feels reasonable; it drops ten degrees the moment the sun goes down near the water.',
    },
    {
      heading: 'The ones worth the drive',
      body: 'If you can only do one with small kids, do Carpinteria. It is the shortest, the crowd is the most forgiving, and you can park two blocks away and walk. Downtown is the most beautiful and the hardest — plan on parking in a garage and walking six or seven blocks with a stroller.',
    },
  ],
  lightings: [
    {
      name: 'Carpinteria tree lighting',
      date: 'Fri, Nov 28',
      time: '5:30pm',
      place: 'Linden Ave & 8th',
      note: 'The easiest one with under-fives. Short program, free cocoa, street parking two blocks off Linden.',
    },
    {
      name: 'Downtown Santa Barbara',
      date: 'Sat, Nov 29',
      time: '6:00pm',
      place: 'State St at De la Guerra',
      note: 'The biggest and the prettiest. Park in the Granada garage and walk — surface parking is gone by five.',
    },
    {
      name: 'Goleta Old Town',
      date: 'Fri, Dec 5',
      time: '5:30pm',
      place: 'Hollister Ave',
      note: 'Genuinely local and rarely crowded. Best one if you have a kid who hates crowds.',
    },
    {
      name: 'Montecito Upper Village',
      date: 'Sat, Dec 6',
      time: '5:00pm',
      place: 'East Valley Rd',
      note: 'Starts earliest, which makes it the winner for a 7pm bedtime. Very little parking.',
    },
  ],
  relatedPosts: [
    { title: 'Holiday Parade with kids: where to stand', category: 'Seasonal' },
    { title: 'Winter break: 14 days, 14 ideas', category: 'Things to do' },
  ],
}
